import React from 'react';
import PropTypes from 'prop-types';
import { Card } from './styles';

const CardDescription = ({ title, children }) => (
  <Card>
    <p className="title">{title}</p>
    {children}
  </Card>
);

CardDescription.defaultProps = {
  title: 'Default',
  children: [<div>Nothing</div>],
};

CardDescription.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
};

export default CardDescription;
